import React, { useState } from 'react';
import './SaludPanelDrawer.css';

// Panel de salud — drawer LECTOR PURO. Recibe la respuesta de /api/salud/panel (App la
// pide) y la muestra por ACCIÓN. Tres estados que se ven: acciones, «todo al día» (vacío
// con fecha), y «desactualizado» (el job no corrió recién) — nunca un cero mudo.

const CHIP = { caja: 'caja', comision: 'comisión', costo: 'costo' };
const fmt = (n) => `$${Math.round(Number(n) || 0).toLocaleString('es-CO')}`;
function haceCuanto(iso) {
  if (!iso) return '';
  const s = Math.floor((Date.now() - new Date(iso).getTime()) / 1000);
  if (s < 60) return 'hace instantes';
  if (s < 3600) return `hace ${Math.floor(s / 60)} min`;
  if (s < 86400) return `hace ${Math.floor(s / 3600)} h`;
  return `hace ${Math.floor(s / 86400)} d`;
}

function FilaAccion({ accion, onNavigate }) {
  const [abierto, setAbierto] = useState(false);
  const esCosto = accion.tipo === 'cargar_costo';
  return (
    <li className="salud-accion">
      <div className="salud-accion-head">
        <div className="salud-accion-texto">
          <span className="salud-accion-titulo">{accion.titulo}</span>
          <span className="salud-accion-cierra">
            cierra: {(accion.cierra || []).map((c) => <span key={c} className="salud-chip">{CHIP[c] || c}</span>)}
          </span>
        </div>
        {esCosto && accion.detalle?.items?.length > 0 && (
          <button className="salud-toggle" onClick={() => setAbierto((v) => !v)}>
            {abierto ? 'Ocultar' : `Ver ${accion.detalle.productos}`}
          </button>
        )}
        {!esCosto && accion.ir_a && (
          <button className="salud-ir" onClick={() => onNavigate?.(accion.ir_a.modulo, { recordId: accion.ir_a.id })}>Ir al pedido</button>
        )}
      </div>
      {esCosto && (
        <div className="salud-accion-sub">{accion.detalle.pedidos} pedido(s) · {fmt(accion.detalle.ventas)} en ventas</div>
      )}
      {esCosto && abierto && (
        <ul className="salud-lista">
          {accion.detalle.items.map((it) => (
            <li key={`${it.productId}:${it.variationId}`} className="salud-item">
              <span className="salud-item-nombre">{it.producto}{it.variacion ? ` — ${it.variacion}` : ''}</span>
              <span className="salud-item-datos">{it.pedidos} ped · {fmt(it.ventas)}</span>
              <button className="salud-ir salud-ir--sm" onClick={() => onNavigate?.('costs', { tab: 'declarados', recordId: it.productId, variationId: it.variationId })}>Declarar costo</button>
            </li>
          ))}
        </ul>
      )}
    </li>
  );
}

export default function SaludPanelDrawer({ open, data, onClose, onNavigate }) {
  if (!open) return null;
  return (
    <>
      <div className="salud-overlay" onClick={onClose} />
      <aside className="salud-drawer" role="dialog" aria-label="Panel de salud">
        <header className="salud-drawer-head">
          <h2>Panel de salud</h2>
          <button className="salud-close" onClick={onClose} aria-label="Cerrar">✕</button>
        </header>

        {!data && <div className="salud-msg">Cargando…</div>}

        {data && data.estado === 'sin_datos' && (
          <div className="salud-msg salud-msg--warn">
            El panel todavía no se calculó (el chequeo automático no corrió aún). Vuelve en unos minutos.
          </div>
        )}

        {data && data.estado === 'desactualizado' && (
          <div className="salud-msg salud-msg--warn">
            ⚠️ Estos datos son de {haceCuanto(data.generado_en)} — el chequeo automático no corrió recién. Puede haber cambios sin reflejar.
          </div>
        )}

        {data && data.vacio && data.estado !== 'sin_datos' && (
          <div className="salud-vacio">
            <span className="salud-vacio-icono">✓</span>
            <strong>Todo al día</strong>
            <span>Todos los productos vendidos tienen costo y todos los pedidos están en una caja.</span>
            <span className="salud-vacio-fecha">Última verificación: {haceCuanto(data.generado_en)}</span>
          </div>
        )}

        {data && !data.vacio && data.acciones?.length > 0 && (
          <>
            <ul className="salud-acciones">
              {data.acciones.map((a, i) => <FilaAccion key={`${a.tipo}-${i}`} accion={a} onNavigate={onNavigate} />)}
            </ul>
            <footer className="salud-drawer-foot">Última verificación: {haceCuanto(data.generado_en)}{data.corte ? ` · desde el corte ${data.corte}` : ''}</footer>
          </>
        )}
      </aside>
    </>
  );
}
